import React, { createContext, useContext, useState, ReactNode } from 'react';
import SnackBar from '../components/SnackBar';
// import SnackBar from '../components/SnackBar';
// import SnackBar from './SnackBar';

type SnackBarContextType = {
  showSnackBar: (
    message: string,
    severity?: 'success' | 'error' | 'warning' | 'info',
  ) => void;
};

const SnackBarContext = createContext<SnackBarContextType | undefined>(
  undefined,
);

export const useSnackBar = () => {
  const ctx = useContext(SnackBarContext);
  if (!ctx) throw new Error('useSnackBar must be used within SnackBarProvider');
  return ctx;
};

const SnackBarProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState<
    'success' | 'error' | 'warning' | 'info'
  >('success');

  const showSnackBar = (
    msg: string,
    sev: 'success' | 'error' | 'warning' | 'info' = 'success',
  ) => {
    setMessage(msg);
    setSeverity(sev);
    setOpen(true);
  };

  return (
    <SnackBarContext.Provider value={{ showSnackBar }}>
      {children}
      <SnackBar
        open={open}
        onClose={() => setOpen(false)}
        message={message}
        severity={severity}
      />
    </SnackBarContext.Provider>
  );
};

export default SnackBarProvider;
